import { ProductAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import KoSchema from '@bingads-webui-component-legacy/ko-schema/index';

export default class ViewModel {
  constructor({ model = null }) {
    KoSchema.properties(this, ProductAd, [], model);
  }
}
